import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const ViewModal = ({ show, handleClose }) => {

    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">View Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Render row details */}
                    <div className="row">
                        <div className="col-md-12 mb-2">
                            <span style={{fontWeight: 'bold'}}>Title</span>
                            <p>Task 1</p>
                        </div>
                        <div className="col-md-12 mb-2">
                            <span style={{fontWeight: 'bold'}}>Description:</span>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Assigned To:</span>
                            <p>User 1</p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Priority:</span>
                            <p><span className='badge bg-success'>High</span></p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Due Date:</span>
                            <p><span className='badge bg-info'> 2024-03-01T13:20:00</span></p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Tags</span>
                            <p className='d-flex gap-2'><span className='badge bg-warning'>Tag1</span><span className='badge bg-warning'>Tag1</span></p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Added By</span>
                            <p><span className='badge bg-warning'> Admin</span></p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Updated By</span>
                            <p><span className='badge bg-warning'> User 1</span></p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Created At</span>
                            <p><span className='badge bg-info'> 2024-03-01T13:20:00</span></p>
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{fontWeight: 'bold'}}>Updated At</span>
                            <p><span className='badge bg-info'> 2024-03-02T09:45:00</span></p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ViewModal;